import React from 'react';
import { ConsultProvider } from './contexts/ConsultContext';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { StatStrip } from './components/StatStrip';
import { WhyItWorks } from './components/WhyItWorks';
import { Process } from './components/Process';
import { LeadMagnet } from './components/LeadMagnet';
import { Results } from './components/Results';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
import { StickyCta } from './components/StickyCta';
import { ConsultDialog } from './components/ConsultDialog';
interface AppProps {
  heroLayout?: 'split' | 'centered';
  showStickyCta?: boolean;
}
export function App({
  heroLayout = 'split',
  showStickyCta = true
}: AppProps) {
  return <ConsultProvider data-id="element-0" data-mp="28suw6sn6u7od">
      <div className={`w-full bg-white font-sans text-ash-900 ${showStickyCta ? 'pb-16 lg:pb-0' : ''}`} data-id="element-1" data-mp="28sbend1g9lav">
        <SiteHeader data-id="element-2" data-mp="23ti7018ugoim" />
        <main data-id="element-3" data-mp="3ik7k0rkruvvx">
          <Hero layout={heroLayout} data-id="element-4" data-mp="3ikqy1x7ax04o" />
          <StatStrip data-id="element-5" data-mp="3ijpd910hgz9r" />
          <WhyItWorks data-id="element-6" data-mp="3ii4q3wgi0ilx" />
          <Process data-id="element-7" data-mp="3ml13n8r6loj0" />
          <LeadMagnet data-id="element-8" data-mp="3mkhmvvd9p66k" />
          <Results data-id="element-9" data-mp="3mjq1fdddwou0" />
          <Faq data-id="element-10" data-mp="3mj6hjr46bqdc" />
          <FinalCta data-id="element-11" data-mp="3rcj6618urx63" />
        </main>
        <SiteFooter data-id="element-12" data-mp="3rdarmj8qkein" />
        {showStickyCta && <StickyCta data-id="element-13" data-mp="3recbnd7qcbci" />}
        <ConsultDialog data-id="element-14" data-mp="5ot150vj28n" />
      </div>
    </ConsultProvider>;
}